import React from 'react';
import { convertCelsiusToFahrenheit } from '../utils/helpers';
import { useUser } from '../context/userContext';

interface OutdoorCardProps {
  temperature: number | string;
  text: string;
  isHumidity?: boolean;
}

const OutdoorCard: React.FC<OutdoorCardProps> = ({ temperature, text, isHumidity = false }) => {
  const { unit } = useUser();

  const displayTemperature = unit === 'Fahrenheit' ? convertCelsiusToFahrenheit(temperature as number) : temperature;
  const unitSymbol = unit === 'Fahrenheit' ? '°F' : '°C';

  return (
    <div className="temperatureCard outdoorCard">
      {isHumidity ? (
        <h3>{text}:<span>{temperature}%</span></h3>
      ) : (
        <h3>{text}:<span>{displayTemperature}{unitSymbol}</span></h3>
      )}
    </div>
  );
}

export default OutdoorCard;
